import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../app.state';
import { authReducer } from './auth.reducer';
import { fcmReducer } from './fcm.reducer';
import { inventoryReducer } from './inventory.reducer';
import { marketPlaceReducer } from './marketplace.reducer';
import { paymentReducer } from './payment.reducer';
import { userReducer } from './user.reducer';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  user: userReducer,
  inventory: inventoryReducer,
  marketplace: marketPlaceReducer,
  payment: paymentReducer,
  fcm: fcmReducer,
};
